import { Component, EventEmitter, Input, Output, OnInit, ElementRef, OnChanges, SimpleChanges, ViewChild, Renderer2, NgZone, ChangeDetectionStrategy } from '@angular/core';

import { FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { FormElementBase } from './classes';

import { Select2ArrayDataAdapter } from './interface';

import { FormService, SharedService, Select2Service } from './service';
import { AppConfig } from '../app.config';
import * as _ from 'lodash';
import { VideoTrimmerComponent } from './utils/video-trimer.component';
import { RangeSliderComponent } from './utils/range-slider.component';
import { NexiComponent } from '../billing/nexi.component';

// tslint:disable: max-classes-per-file
// tslint:disable: no-access-missing-member

@Component({
    selector: 'language-flag',
    template: `
    <span class="d-inline-flex align-items-center" (click)="shared.language = language" role="button">
        <i class="flag {{flagIconClass}}"></i>
        <span class="ml-2" *ngIf="!onlyFlag" [innerHTML]="languageText"></span>
    </span>`
})
export class CommonLanguageFlagComponent implements OnChanges {
    @Input() public language: string;
    @Input() public onlyFlag: boolean = false;

    private appConfig;
    constructor(
        app: AppConfig,
        private shared: SharedService,
        private el: ElementRef,
    ) {
        this.appConfig = app.getConfig();
    }

    public get flagIconClass(): string {
        switch (this.language) {
            // case 'en': return 'flag-GB';
            case 'en':
            case 'en-US': return 'flag-US';
            case 'en-GB': return 'flag-GB';
            case 'en-CA': return 'flag-CA';
            default: return `flag-${(this.language || '').toUpperCase()}`;
        }
    }

    public get languageText(): string {
        switch (this.language) {
            case 'en': case 'en-US': case 'en-CA': case 'en-GB': return 'English';
            case 'it': return 'Italiano';
            case 'es': return 'Español';
            case 'pt': return 'Português';
            case 'fr': return 'Français';
            default: return this.language;
        }
    }

    public ngOnChanges(changes: SimpleChanges) {
        const { directopubConfig } = this.shared;
        const languages = directopubConfig && directopubConfig.language ? directopubConfig.language : this.appConfig.languages;
        const plainLangs = languages.map((l) => _.isString(l) ? l : l.key);
        if (changes.language && plainLangs.indexOf(changes.language.currentValue) < 0) {
            $(this.el.nativeElement).hide();
        }
    }
}

@Component({
    selector: '[i18neditor]',
    // tslint:disable-next-line: no-access-missing-member
    template: `
    <div class="my-component bg-info">
      <div ng-transclude></div>
    </div>`,
    // changeDetection: ChangeDetectionStrategy.Default
})
export class TranslationEditorComponent implements OnChanges, OnInit {
    @Input() public key: string;
    private appConfig;
    constructor(
        app: AppConfig,
        private shared: SharedService,
        private el: ElementRef
    ) {
        this.appConfig = app.getConfig();
    }

    public ngOnChanges(changes: SimpleChanges) {
        // ddsd
    }
    public ngOnInit() {
        console.log('inititalized > ', this.key)
    }
}

@Component({
    selector: 'select-rate-card',
    template: '<select #el id="{{selectoptions.id}}" name="{{selectoptions.name}}" (change)="onChange($event)" required={{selectoptions.required}} data-theme="bootstrap" data-animation="true" class="select2 form-control"></select>',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SelectComponent implements OnInit {
    /*
    required: boolean;
    disabled: boolean;
    placeholder: string;
    allowClear: boolean;
    apiurl: string; 
    id: string; 
    name: string;
    multiple: boolean, 
    dropdownparent: string,
    selectedId:any[]
    */
    @Input() selectoptions: any;
    @Output() onChangeSelected = new EventEmitter<boolean>();
    selectConfig: any;
    customAdapter: any;
    limit: any;
    @ViewChild('el', { read: ElementRef }) el: ElementRef;

    constructor(
        private dataService: Select2Service,
        private renderer: Renderer2,
        private ngZone: NgZone,
        private translate: TranslateService

    ) { }

    /* init(){
       let dataapi = this.dataService;
       let path = this.selectoptions.apiurl || null;
       let term = null;
       
      $.fn.select2.amd.define('select2/data/customdatadapter',[
        'select2/data/array',
        'select2/utils'
      ],
      (ArrayDataAdapter: Select2ArrayDataAdapter, Utils) => {
       class CustomDataAdapter extends ArrayDataAdapter {     
        constructor($element: JQuery, options) {
          super($element, options);
        }
        
        public query = function(params:any,callback:any){
            console.log(params);
            let data: { results?: Array<{ id: number | string; text: string }> ; pagination?: { more?: boolean; } };
                 data = {results: []};
                 term = params.term || null;
                
                 dataapi.getData(term,path,offset).subscribe((res: any) => { 
                  res.forEach((value:any)=>{
                    data.results.push({'id': value.id.toString(), 'text': value.name});
                  });  
                 callback(data);          
              });
        };
       }
        return CustomDataAdapter;
      });
     }*/
    onChange(event: any) {
        // console.log(event);
        //this.selectoptions.selectedId = event;
        this.onChangeSelected.emit(event);
    }

    public ngOnInit(): void {
        this.translate.get(this.selectoptions.placeholder)
            .toPromise()
            .then((r) => {
                this.limit = '1500';
                //this.init();
                //let customApiadapter = $.fn.select2.amd.require('select2/data/customdatadapter');    
                this.selectConfig = {
                    data: [],
                    multiple: this.selectoptions.multiple,
                    dropdownParent: $(this.selectoptions.dropdownparent),
                    disabled: this.selectoptions.disabled,
                    placeholder: r,
                    //dataAdapter: customApiadapter 

                    ajax: {
                        dataType: 'json',
                        delay: 300,
                        data: (params: any) => {
                            // console.log(params);
                            return {
                                term: params.term,
                                page: params.page || 1
                            };
                        },
                        transport: (params: any, success: any, failure: any) => {
                            let term = params.data.term || null;
                            let offset = (params.data.page > 1) ? (params.data.page - 1) * this.limit : 0;
                            this.dataService.getData(term, this.selectoptions.apiurl, offset, this.limit).subscribe((res: any) => {
                                res.page = (offset > 0) ? Math.ceil(offset / this.limit) + 1 : 1;
                                success(res);
                            },
                                (error: any) => {
                                    failure(error);
                                });
                        },
                        processResults: function (res: any, params: any) {
                            params.page = params.page || 1;
                            let items = [];
                            res.data.forEach((value: any) => {
                                items.push({ 'id': value.id.toString(), 'text': value.name });
                            });
                            return {
                                pagination: {
                                    more: (params.page * 10) < res._pagination.totalCount
                                },
                                results: items,
                                page: params.page
                            };
                        }
                    }

                }
                this.ngZone.runOutsideAngular(() => {
                    $(this.el.nativeElement).select2(this.selectConfig);
                    this.selectoptions.selectedId.forEach((value: any) => {
                        var newOption = new Option(value.text, value.id, true, true);
                        // Append it to the select
                        $(this.el.nativeElement).append(newOption).trigger('change');
                    });
                });
                $(this.el.nativeElement).on("change", (e) => {
                    let selected = [];
                    // console.log($(this.el.nativeElement).select2('data'));
                    selected = $(this.el.nativeElement).select2('data').map((value: any) => {
                        return value;
                    })
                    this.onChange(selected);
                });
            });
    }
}


@Component({
    selector: 'formatted-input',
    template: `
        <input type="text"
            id="{{id}}"
            name="{{name}}"
            class="{{inputClass}} form-control"
            [ngModel]="input"            
            (ngModelChange)="callParent($event)"            
        />
    `,
    // styles: [require('./app-input.component.scss')]
})
export class FormattedInput {
    @Input() inputModel: string;
    @Input() inputClass: string;   
    @Input() id: string;   
    @Input() name: string;   
    @Output() customEvent = new EventEmitter<string>();
 
    constructor() { }

    public ngOnInit() {
        if ( ! this.AutoNumeric ) {
            $('head').append('<script src="https://cdn.jsdelivr.net/npm/autonumeric" ></script>')
        }
    }

    public ngAfterViewInit() {
        this.initFields()
    }

    public ngOnChanges(changes: SimpleChanges) {
        for (let propName in changes) {
            if ( propName == 'inputModel' ) {
                if (this.formatted) this.formatted.set(changes.inputModel.currentValue)
            }
            // console.log('changes',propName, changes.inputModel)
            /*let chng = changes[propName];
            let cur  = JSON.stringify(chng.currentValue);
            let prev = JSON.stringify(chng.previousValue);
            this.changeLog.push(`propName: currentValue = cur, previousValue = prev`);*/
        }
    }

    public formatted 

    get AutoNumeric () {
        return window['AutoNumeric']
    }

    get input():number {
        return this.formatted ? Number(this.formatted.get()) : 0
    }

    set input(value) {
        if ( this.formatted ) this.formatted.set(value)
    }

    public initFields() {
        setTimeout( () => {
            this.formatted = new this.AutoNumeric( '#'+this.id , this.inputModel,  {
                decimalPlaces: 0, 
                digitGroupSeparator:' ',
                decimalCharacter:',',
            });
        }, 100 )

    }

      
    public callParent(event: string): void {
        // console.log('custom on change',event)
        let v = this.formatted.get()
        this.customEvent.emit(v)
    }

}


// @Component({
//     selector: 'formatted-input',
//     template: '<input type="text" id="{{id}}" name="{{name}}" [ngModel]="inputText" (ngModelChange)="onChange()" class="{{customClasses}} form-control"  >',
//     changeDetection: ChangeDetectionStrategy.OnPush
// })
// export class FormattedInput implements OnInit {
//     @Input() id?: string;
//     @Input() name?: string;
//     @Input() customClasses?: string;
//     @Output() onModelChange = new EventEmitter();
    
//     private inputText: string

//     ngOnInit(): void {
//         console.log('init', Input)
//     }

//     onChange(event: any) {
//         console.log(event);
//         //this.selectoptions.selectedId = event;
//         this.onModelChange.emit(event);
//     }

// }


export const COMMON_COMPONENTS = [
    CommonLanguageFlagComponent,
    TranslationEditorComponent,
    SelectComponent,
    VideoTrimmerComponent,
    RangeSliderComponent,
    FormattedInput,
    NexiComponent
];



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/common/component.ts